export default __webpack_public_path__ + "static/media/middle-baner.01c81b68.gif";